/**
 * MonthRunPillSlot: where the month run's pill mounts in the app shell (runmin,
 * re-homed by atrest step 7).
 *
 * The shell is the main chunk, and that chunk sits on its 350 KB budget. The pill
 * shows only while this tab's office worker is working a return (and a short
 * while after), so its own code is fetched only then. The status it reads is the
 * worker's, which is already in the shell.
 *
 * A chunk that fails to load (a deploy landed mid-session) draws nothing rather
 * than throwing: this sits above every page, and a missing pill must never take
 * the page down with it. The work itself is unaffected.
 */
import { lazy, Suspense } from 'react';
import { useMonthRunDriverStatus } from '@/shared/office/monthRunStatus';

const MonthRunPill = lazy(() => import('@/shared/components/MonthRunPill')
    .then((m) => ({ default: m.MonthRunPill }))
    .catch(() => ({ default: () => null })));

export function MonthRunPillSlot() {
    const recent = useMonthRunDriverStatus().recent;
    if (!recent) return null;
    return (
        <Suspense fallback={null}>
            <MonthRunPill recent={recent} />
        </Suspense>
    );
}
